import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "components/common/Button/Button";
import * as React from "react";
import { useState } from "react";
import styled from "styled-components";
import theme from "themes/simple-theme";

const StyledButton = styled(Button)`
  width: 160px;
  margin: 2px 6px;
  font-size: 1.4rem;
  padding: 1.6rem 1rem;
`;

const UpdateIcon = styled(FontAwesomeIcon)`
  color: ${theme.color.primary};
  padding: 8px;
`;

const SpinnerIcon = styled(FontAwesomeIcon)`
  color: ${theme.color.primary};
  margin: 10px;
  vertical-align: middle;
`;

const UpdateText = styled.span`
  margin: 8px;
  line-height: 5.8rem;
`;

const UpdateNotificationContainer = styled.div`
  position: fixed;
  bottom: 20px;
  left: 0px;
  margin: 0px;

  padding: 6px;

  font-size: 1.8rem;

  background-color: rgba(255, 255, 255, 0.6);

  border: 1px solid #ccc;
  border-left: none;

  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;

  box-shadow: 5px 5px 6px 0px #777;
`;

export interface IProps {
  autoUpdateStarted: boolean;
  onStartNewVersion(): void;
}

const UpdateNotification = ({
  onStartNewVersion,
  autoUpdateStarted
}: IProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isRestarting, setIsRestarting] = useState(false);

  const touchHandler = () => {
    setIsExpanded(!isExpanded);
  };

  const handleLaunchButtonClicked = () => {
    setIsRestarting(true);
    onStartNewVersion();
  };

  return (
    <UpdateNotificationContainer onClick={touchHandler}>
      {(isRestarting || autoUpdateStarted) && (
        <>
          <UpdateText>App update in progress. Please wait...</UpdateText>
          <SpinnerIcon icon="spinner" size="2x" spin />
        </>
      )}
      {!autoUpdateStarted && isExpanded && (
        <>
          <div>
            <UpdateText>New Version Available:</UpdateText>
            <StyledButton primary onClick={handleLaunchButtonClicked}>
              Update Now
            </StyledButton>
          </div>
        </>
      )}
      {!autoUpdateStarted && !isRestarting && !isExpanded && (
        <UpdateIcon icon="bullhorn" size="2x" />
      )}
    </UpdateNotificationContainer>
  );
};

export default UpdateNotification;



// WEBPACK FOOTER //
// ./src/components/UpdateManager/UpdateNotification.tsx